import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Form } from "react-bootstrap";
import { LoadingSpinner } from "../generalLayout";
import {
  provinces,
  states,
} from "../../constants/provincesAndStates";
import { useState } from "react";

// form validation schema (with Yup)
const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("Please enter your first name"),
  lastName: Yup.string().required("Please enter your last name"),
  phone: Yup.string().matches(
    /^\+?\d{10,14}$/, //regex phone nr
    "Please enter a valid phone number (numbers only)."
  ),
  country: Yup.string(),
  street: Yup.string(),
  city: Yup.string(),
  province: Yup.string(),
  postalCode: Yup.string().when("country", {
    is: (country) => country && country === "Canada",
    then: () =>
      Yup.string().matches(
        /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/, //regex Canadian postal code
        "Please enter a valid Canadian postal code"
      ),
    otherwise: () =>
      Yup.string().matches(
        /^\d{5}(?:[-\s]\d{4})?$/, //regex US zip code
        "Please enter a valid U.S. zip code"
      ),
  }),
  password: Yup.string().required("Please enter a valid password"),
  newPassword: Yup.string().min(
    6,
    "Password must be at least 6 characters long"
  ),
});

export default function ProfileForm(props) {
  // form that allows users to change their profile info

  const [country, setCountry] = useState("Canada");

  const formFields = [
    { name: "firstName", label: "First Name", type: "text" },
    { name: "lastName", label: "Last Name", type: "text" },
    { name: "email", label: "Email", type: "email" },
    { name: "phone", label: "Phone", type: "text" },
    {
      name: "country",
      label: "Country",
      type: "select",
      options: ["Canada", "USA"],
    },
    { name: "street", label: "Street", type: "text" },
    { name: "city", label: "City", type: "text" },
    {
      name: "province",
      label: country==="Canada"?"Province":"State",
      type: "select",
      options: country==="Canada"?provinces:states,
    },
    { name: "postalCode", label: country==="Canada"?"Postal Code":"Zip Code", type: "text" },
    { name: "newPassword", label: "New Password (optional)", type: "password" },
    {
      name: "password",
      label: "*Please enter your current password to confirm your changes.",
      type: "password",
    },
  ];

  return (
    <Formik
      initialValues={{
        firstName: props.profileData.firstName || "",
        lastName: props.profileData.lastName || "",
        email: props.profileData.email || "",
        phone: props.profileData.phone || "",
        country: props.profileData.country || "Canada",
        street: props.profileData.street || "",
        city: props.profileData.city || "",
        province: props.profileData.province || "",
        postalCode: props.profileData.postalCode || "",
        password: "",
        newPassword: "",
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await props.handleSubmitClick(values);
        setSubmitting(false);
      }}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        touched,
        errors,
        isSubmitting,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          {formFields.map((field, idx) => (
            <Form.Group key={idx} className="mb-3" controlId={field.name}>
              <Form.Label className={field.name === "password" ? "mt-4" : ""}>
                {field.label}
              </Form.Label>
              {/* select with dropdown */}
              {field.type === "select" ? (
                <Form.Select
                  size="md"
                  aria-label="Default select example"
                  name={field.name}
                  value={values[field.name]}
                  isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                  onChange={(event) => {
                    if (field.name === "country") {
                      setCountry(event.target.value);
                    }
                    handleChange(event);
                  }}
                >
                <option value="">Please Select</option>
                  {field.options.map((option) => (
                    <option key={option} value={option}> 
                      {option}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <Form.Control //regular field
                  type={field.type}
                  name={field.name}
                  value={values[field.name]}
                  onChange={handleChange}
                  isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                />
              )}
              <Form.Control.Feedback type="invalid">
                {errors[field.name]}
              </Form.Control.Feedback>
            </Form.Group>
          ))}

          <Button type="submit">
            {isSubmitting && <LoadingSpinner button={true} variant="light" />}{" "}
            Save
          </Button>
          <Button
            onClick={props.handleCancel}
            className="ms-3"
            type="button"
            variant="danger"
          >
            Cancel
          </Button>
        </Form>
      )}
    </Formik>
  );
}
